/**
 * Automation Shared Handlers
 */

import { AutomationSharedState } from './state';
import { AutomationSharedCommand } from './commands';
import { CommandHandlerMap } from '@commandDrivenStateEngine/core/types';

type ExtractCommand<T extends string> = Extract<AutomationSharedCommand, { type: T }>;

// Data handlers

const handleSetRules = (
  state: AutomationSharedState,
  cmd: ExtractCommand<'automation/shared/data/setRules'>
): AutomationSharedState => ({
  ...state,
  rules: cmd.payload.rules
});

// Dropdown handlers

const handleDropdownOpen = (
  state: AutomationSharedState,
  _cmd: ExtractCommand<'automation/shared/dropdown/open'>
): AutomationSharedState => ({
  ...state,
  dropdownOpen: true
});

const handleDropdownClose = (
  state: AutomationSharedState,
  _cmd: ExtractCommand<'automation/shared/dropdown/close'>
): AutomationSharedState => ({
  ...state,
  dropdownOpen: false
});

// Loading handlers

const handleSetRulesLoading = (
  state: AutomationSharedState,
  cmd: ExtractCommand<'automation/shared/loading/setRulesLoading'>
): AutomationSharedState => ({
  ...state,
  loading: { ...state.loading, rules: cmd.payload.isLoading }
});

export const handlers: CommandHandlerMap<AutomationSharedState, AutomationSharedCommand> = {
  'automation/shared/data/setRules': handleSetRules,
  'automation/shared/dropdown/open': handleDropdownOpen,
  'automation/shared/dropdown/close': handleDropdownClose,
  'automation/shared/loading/setRulesLoading': handleSetRulesLoading
};
